/* ============================================================
   SKILLS LAB · Negative numbers
   Engine + number-line teach renderer, ported from the live
   /pages/adding-subtracting-negative-numbers tool (v2). One skill,
   eight levels: four kinds of sum, then all sums, then multiply,
   divide, and everything mixed.
   ============================================================ */
(function () {
  'use strict';
  var SL = window.SL; if (!SL) return;
  var MINUS = SL.MINUS, RI = SL.ri, ICON = SL.ICON;
  var R = function (n) { return Math.floor(Math.random() * n); };
  var num = function (n) { return n < 0 ? MINUS + Math.abs(n) : String(n); };
  var say = function (n) { return n < 0 ? 'negative ' + Math.abs(n) : String(n); };

  /* ---------- question model ---------- */
  /* Generation ranges. Each level says how far its numbers may go, so a set is
     not ten sums of the same size. The teach model works its own scale out from
     whatever question it is handed, so nothing here is capped to fit a picture. */
  var RG = { lo: -20, hi: 20, maxb: 12, maxf: 10, hops: 6 };
  function rangeOf(a, b) { var r = {}, k; for (k in RG) r[k] = RG[k]; for (k in (a || {})) r[k] = a[k]; for (k in (b || {})) r[k] = b[k]; return r; }
  function isMD(q) { return q.op === 'x' || q.op === '/'; }
  function effOf(q) {
    if (isMD(q)) return (q.a < 0 ? -1 : 1) * (q.b < 0 ? -1 : 1);
    return (q.op === '+' ? 1 : -1) * (q.b < 0 ? -1 : 1);
  }
  function distOf(q) { return Math.abs(q.b); }
  function answer(q) {
    if (q.op === 'x') return q.a * q.b;
    if (q.op === '/') return q.a / q.b;
    return q.a + effOf(q) * distOf(q);
  }
  function qKey(q) { return q.a + '|' + q.op + '|' + q.b; }
  function opGlyph(q) { return q.op === '+' ? '+' : q.op === '-' ? MINUS : q.op === 'x' ? '×' : '÷'; }
  function opWord(q) { return q.op === '+' ? 'plus' : q.op === '-' ? 'minus' : q.op === 'x' ? 'times' : 'divided by'; }
  function qText(q) { return num(q.a) + ' ' + opGlyph(q) + ' ' + num(q.b); }
  function sayQ(q) { return say(q.a) + ' ' + opWord(q) + ' ' + say(q.b); }
  /* The jumps the walk is drawn in. Levels 1 to 4 teach the sum one place at a
     time, so they count in ones. Level 5 has the sums mixed and the numbers are
     bigger, so it goes in TWO jumps: to zero if the sum crosses it, then straight
     to the answer. A sum that never crosses zero is one jump. */
  function hopsOf(q, two) {
    var w = walkOf(q), out = [], i, from = w.start;
    if (two && !isMD(q)) {
      var a = w.start, b = w.end;
      if ((a < 0 && b > 0) || (a > 0 && b < 0)) return [[a, 0, String(Math.abs(a))], [0, b, String(Math.abs(b))]];
      return [[a, b, String(Math.abs(b - a))]];
    }
    for (i = 1; i <= w.n; i++) { out.push([from, from + w.dir * w.size, String(i)]); from += w.dir * w.size; }
    return out;
  }
  function walkOf(q) {
    if (q.op === 'x') return { start: 0, size: Math.abs(q.a), n: Math.abs(q.b), dir: effOf(q), end: q.ans };
    if (q.op === '/') return { start: q.a, size: Math.abs(q.b), n: Math.abs(q.ans), dir: (q.a < 0 ? 1 : -1), end: 0 };
    return { start: q.a, size: 1, n: distOf(q), dir: effOf(q), end: q.ans };
  }

  var SHAPES_AS = [
    { aNeg: false, op: '-', bNeg: false }, { aNeg: true, op: '-', bNeg: false }, { aNeg: true, op: '+', bNeg: false },
    { aNeg: false, op: '+', bNeg: true }, { aNeg: true, op: '+', bNeg: true }, { aNeg: false, op: '-', bNeg: true }, { aNeg: true, op: '-', bNeg: true }
  ];
  var SHAPES_MD = [
    { aNeg: true, op: 'x', bNeg: false }, { aNeg: false, op: 'x', bNeg: true }, { aNeg: true, op: 'x', bNeg: true },
    { aNeg: true, op: '/', bNeg: false }, { aNeg: false, op: '/', bNeg: true }, { aNeg: true, op: '/', bNeg: true }
  ];

  function makeAS(si, seen, fixedA, rg, fresh) {
    var sh = SHAPES_AS[si], guard = 0, best = null, ok = null;
    rg = rg || RG;
    while (guard++ < 600) {
      var a = (fixedA === undefined) ? (sh.aNeg ? RI(rg.lo + 1, -1) : RI(1, rg.hi - 1)) : fixedA;
      var dist = RI(1, rg.maxb);
      var q = { a: a, op: sh.op, b: sh.bNeg ? -dist : dist, kind: 'as', s: si };
      var ans = answer(q);
      if (ans < rg.lo || ans > rg.hi) continue;
      if (si === 0 && ans >= 0) continue;
      q.ans = ans;
      if (!best) best = q;
      if (seen[qKey(q)]) continue;
      if (!ok) ok = q;
      if (!fresh || fresh(q)) return q;
    }
    return ok || best || { a: 4, op: '-', b: 7, ans: -3, kind: 'as', s: 0 };
  }
  /* multiply and divide: the walk is `hops` jumps of `size`, so hops stays small
     and the size grows. That gives 12 x 7 and 84 / 12, not ten sums under 20. */
  function makeMD(si, seen, rg, fresh) {
    var sh = SHAPES_MD[si], guard = 0, best = null, ok = null;
    rg = rg || RG;
    while (guard++ < 600) {
      var size = RI(2, rg.maxf), n = RI(2, rg.hops), q;
      if (sh.op === 'x') {
        /* either factor may be the big one, as long as the jumps stay countable */
        if (Math.random() < 0.5 && size <= rg.hops && n <= rg.maxf) { var t = size; size = n; n = t; }
        q = { a: sh.aNeg ? -size : size, op: 'x', b: sh.bNeg ? -n : n, kind: 'md', s: si };
      } else q = { a: sh.aNeg ? -size * n : size * n, op: '/', b: sh.bNeg ? -size : size, kind: 'md', s: si };
      q.ans = answer(q);
      if (!best) best = q;
      if (seen[qKey(q)]) continue;
      if (!ok) ok = q;
      if (!fresh || fresh(q)) return q;
    }
    return ok || best;
  }

  var ALL_AS = [0, 1, 2, 3, 4, 5, 6], ALL_MD = [0, 1, 2, 3, 4, 5];
  /* quota: kinds per set of ten, dealt from a woven plan by the deal kit. 'as' is an
     add or subtract sum, 'md' a multiply or divide. Only level 8 has both: 5 and 5,
     two operations in each family, never three of one family running. */
  var LEVELS = [
    { name: 'Subtract past zero', eg: '8 ' + MINUS + ' 15', as: [0], md: [], rg: { hi: 20, maxb: 18 }, quota: { as: 10 } },
    { name: 'Start on a negative number', eg: MINUS + '5 ' + MINUS + ' 9,  ' + MINUS + '16 + 4', as: [1, 2], md: [], rg: { lo: -25, hi: 25, maxb: 16 }, quota: { as: 10 } },
    { name: 'Add a negative number', eg: '5 + ' + MINUS + '12,  ' + MINUS + '9 + ' + MINUS + '7', as: [3, 4], md: [], rg: { lo: -30, hi: 30, maxb: 18 }, quota: { as: 10 } },
    { name: 'Subtract a negative number', eg: '3 ' + MINUS + ' ' + MINUS + '14', as: [5, 6], md: [], rg: { lo: -30, hi: 30, maxb: 18 }, quota: { as: 10 } },
    { name: 'Add and subtract, all kinds', eg: MINUS + '17 + 24,  8 ' + MINUS + ' ' + MINUS + '19', as: ALL_AS, md: [], rg: { lo: -40, hi: 40, maxb: 26 }, quota: { as: 10 } },
    { name: 'Multiply', eg: MINUS + '7 × 8,  ' + MINUS + '12 × ' + MINUS + '5', as: [], md: [0, 1, 2], rg: { maxf: 12, hops: 8 }, quota: { md: 10 } },
    { name: 'Divide', eg: MINUS + '84 ÷ 12,  56 ÷ ' + MINUS + '7', as: [], md: [3, 4, 5], rg: { maxf: 12, hops: 8 }, quota: { md: 10 } },
    { name: 'Everything mixed', eg: 'add, subtract, multiply and divide', as: ALL_AS, md: ALL_MD, rg: { lo: -40, hi: 40, maxb: 26, maxf: 12, hops: 8 }, quota: { as: 5, md: 5 } }
  ];

  function exprHTML(q) {
    return '<span class="num">' + num(q.a) + ' ' + opGlyph(q) + ' ' + num(q.b) + '</span>';
  }
  /* ---------- dealing: the deal kit (src/kits/deal.js) ----------
     Core hands a BRAND NEW ctx for every set of ten, and Speed swaps its ctx every
     ten questions inside one race, so nothing that stops a repeat may live on the
     ctx. The kit keeps the last nine questions at each level ON THE MODULE (key,
     printed sum, answer, the near-identical `also` keys) with a three-deep kind
     tail, and deals each set's kinds from a woven plan of ten (LEVELS quota).
     Inside a family the shape (which signs, which operation) is balanced over the
     set and never the same twice running, as the levels have always dealt it. */
  var D, TRY = {}, SETID = 0;
  /* the last few numbers used, so a run does not lean on 12 and 20 all the way
     down: the sizes of the last four questions at this level, seven numbers,
     read from the kit's window so they carry across the set seam */
  function freshFor(S) {
    var r = [];
    S.recent(4).forEach(function (h) { r.push(Math.abs(h.q.a), Math.abs(h.q.b)); });
    r = r.slice(-7);
    return function (q) { return r.indexOf(Math.abs(q.a)) < 0 && r.indexOf(Math.abs(q.b)) < 0 && r.indexOf(Math.abs(q.ans)) < 0; };
  }
  /* which shape of the family: least used in this set, never the last one dealt.
     A slot that cannot be dealt clean lets go of the set's balance first (after
     100 tries), then of "not the last shape" (after 180), so the window of nine
     and a fresh answer are always kept when they can be. */
  function pickShape(fam, S, t) {
    var list = fam === 'as' ? S.L.as : S.L.md, used = {}, lastS = null, min = Infinity, last, pool;
    if (list.length === 1) return list[0];
    if (t > 180) return list[R(list.length)];
    S.recent(9).forEach(function (h) { if (h.q.__set === S.set.id && h.kind === fam) used[h.q.s] = (used[h.q.s] || 0) + 1; });
    last = S.recent(1)[0];
    if (last && last.kind === fam) lastS = last.q.s;
    pool = list.filter(function (s) { return s !== lastS; });
    if (t > 100) return pool[R(pool.length)];
    pool.forEach(function (s) { min = Math.min(min, used[s] || 0); });
    pool = pool.filter(function (s) { return (used[s] || 0) === min; });
    return pool[R(pool.length)];
  }
  /* the numbers-used preference is let go after 60 tries of a slot: on a small
     level (divide has seven negative answers) it would otherwise hide the one
     fresh answer left and push the set off its balance */
  function roll(level, fam, S) {
    var t = TRY[fam] = (TRY[fam] || 0) + 1, si, rg = rangeOf(S.L.rg), win = {}, fresh = t <= 60 ? freshFor(S) : null, q;
    S.set.id = S.set.id || ++SETID;   /* S.set is new with every plan of ten */
    si = pickShape(fam, S, t);
    S.recent(9).forEach(function (h) { win[h.key] = 1; });
    q = fam === 'as' ? makeAS(si, win, undefined, rg, fresh) : makeMD(si, win, rg, fresh);
    if (!q) return null;
    q.key = qKey(q); q.__set = S.set.id;
    return q;
  }
  /* near-identical over the last nine: the same two numbers turned round
     (−5 + −9 and −9 + −5, −7 × 8 and 8 × −7), or a division with the same sizes */
  function alsoOf(q) {
    var x = Math.abs(q.a), y = Math.abs(q.b);
    if (q.op === '+') return ['+' + Math.min(q.a, q.b) + '&' + Math.max(q.a, q.b)];
    if (q.op === 'x') return ['x' + Math.min(x, y) + '&' + Math.max(x, y)];
    if (q.op === '/') return ['/' + x + '&' + y];
    return [];
  }
  function make(level, ctx) {
    D = D || SL.kits.deal({ levels: LEVELS, roll: roll, pack: pack, text: qText, also: alsoOf,
      answer: function (q) { return num(q.ans); } });
    TRY = {};
    return D.make(level, ctx);
  }
  function pack(q, level) {
    return { key: qKey(q), html: exprHTML(q), text: qText(q), ansHTML: '<span class="num">' + num(q.ans) + '</span>',
             ansText: num(q.ans), data: q, level: level };
  }

  /* ============================================================
     TEACH: the number line, three presses
     ============================================================ */
  function teach(host, item, api) {
    var q = item.data, fast = !!api.reduceMotion, lStep = 0, busy = false, timers = [], dead = false;
    var baseFast = fast;
    var LVL = item.level || 0, TWO = (LVL === 5);
    /* Your turn drives this same renderer: the pupil answers each step before it
       is drawn. quizMode changes only the LINE - a wider unit and a hit under
       every whole number, because now it is being tapped, not read. */
    var quiz = null, quizMode = false;
    function tstep() { return quizMode ? 1 : TSTEP; }
    function hops() { return hopsOf(q, TWO); }
    /* The line fits itself to THIS question: it works out its own low, high,
       tick step and label step from the walk. Nothing in the generator is held
       back to suit a fixed -20 to 20 line. */
    var vLo, vHi, vN, TSTEP, MSTEP;
    function computeScale() {
      var w = walkOf(q), lo = Math.min(w.start, w.end, 0), hi = Math.max(w.start, w.end, 0);
      /* Your turn finishes by tapping the answer, and a QUOTIENT's answer is a
         count of jumps, not the place the walk stops: 40 ÷ −5 walks 40 down to
         zero and answers −8, which is nowhere on a line drawn for that walk.
         So while the line is being tapped it has to reach the answer as well. */
      if (quizMode) { lo = Math.min(lo, q.ans); hi = Math.max(hi, q.ans); }
      var pad = Math.max(2, Math.round((hi - lo) * 0.12));
      lo -= pad; hi += pad;
      if (hi - lo < 20) { var mid = Math.round((lo + hi) / 2); lo = mid - 10; hi = mid + 10; }
      vLo = Math.floor(lo / 5) * 5; vHi = Math.ceil(hi / 5) * 5;
      vN = vHi - vLo + 1;
      TSTEP = vN <= 61 ? 1 : (vN <= 121 ? 2 : 5);
      MSTEP = vN <= 61 ? 5 : (vN <= 121 ? 10 : 20);
    }
    computeScale();
    host.innerHTML =
      '<div class="sl-nl">' +
        '<div class="nl-linebox"><div class="nl-linescroll"><div class="nl-linestage">' +
          '<svg class="nl-svg" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"></svg><div class="nl-hits"></div>' +
        '</div></div></div>' +
        '<div class="nl-expr" aria-hidden="true"></div>' +
        '<div class="nl-cap"><span></span></div>' +
        (isMD(q) ? '' : '<div class="nl-tapnote">Tap any number on the line to start the calculation somewhere else</div>') +
      '</div>';
    var root = host.querySelector('.sl-nl'), elBox = root.querySelector('.nl-linebox'), elScroll = root.querySelector('.nl-linescroll'),
        elStage = root.querySelector('.nl-linestage'), elSvg = root.querySelector('.nl-svg'), elHits = root.querySelector('.nl-hits'),
        elExpr = root.querySelector('.nl-expr'), elCap = root.querySelector('.nl-cap');

    function clearTimers() { timers.forEach(clearTimeout); timers = []; }
    function later(fn, ms) { var t = setTimeout(function () { if (!dead) fn(); }, fast ? Math.min(ms, 12) : ms); timers.push(t); return t; }
    function setBusy(on) { busy = !!on; }

    /* ---------- the line ---------- */
    var SVGNS = 'http://www.w3.org/2000/svg';
    var ppu = 30, PADX = 26, W = 0, H = 138, AXIS = 98, LABY = 124, HOPH = 28;
    var labs = {}, hits = {}, hitList = [], hopHost = null, elMarker = null, elGhost = null, elSpot = null;
    var curV = 0, markerShown = false, camLock = false, hitsOn = false, hitsPred = null;
    function mk(tag, attrs) { var e = document.createElementNS(SVGNS, tag); for (var k in attrs) if (attrs.hasOwnProperty(k)) e.setAttribute(k, attrs[k]); return e; }
    function X(v) { return PADX + (v - vLo) * ppu; }
    /* the widest label the line will write, measured in the line's own units
       (the board's zoom scales the units and the type together) */
    var LABW = 0;
    function labWidest() {
      try {
        var a = num(vLo), b = num(vHi), t = mk('text', { x: 0, y: -60, 'class': 'nl-lab maj' });
        t.textContent = a.length >= b.length ? a : b;
        elSvg.appendChild(t); var w = t.getBBox().width; elSvg.removeChild(t);
        return w || 0;
      } catch (e) { return 0; }
    }
    /* Packed line: -35 to 5 on a wide board gave every whole number a label,
       and three-character labels ran into each other ("-35-34-33"). The
       label step is the smallest of the line's own steps that leaves a clear
       gap between two labels; the ticks stay on every number. */
    function labStep() {
      var TS = tstep(), c = TS === 1 ? [1, 5, 10, 20, 50] : (TS === 2 ? [2, 10, 20, 50] : [5, 10, 20, 50, 100]);
      for (var i = 0; i < c.length; i++) if (c[i] * ppu >= LABW + 12) return c[i];
      return c[c.length - 1];
    }
    function measure() {
      var availW = elScroll.clientWidth || 340;
      /* the line fills the box. The old cap of 44 pixels a unit left a short
         run sitting in the left two thirds of a wide stage with dead space
         beside it; now the cap is generous, whatever is left over becomes
         padding, and the line is centred in the box it is given. */
      var fit = (availW - 52) / Math.max(1, vN - 1);
      LABW = labWidest();
      /* while it is being tapped every whole number carries a label, so the
         units never close up past the width a label needs: the line scrolls */
      ppu = Math.min(140, Math.max(quizMode ? Math.max(24, LABW + 12) : 9, fit));
      var wide = (vN - 1) * ppu;
      PADX = Math.max(26, Math.round((availW - wide) / 2));
      W = Math.max(availW, PADX * 2 + wide);
      H = elStage.clientHeight || 150;
      /* the arcs grow with the hops, so a wide line is not drawn with the same
         flat 28 pixel bumps it had when everything was squeezed up */
      HOPH = Math.max(10, Math.min(Math.max(24, H - 96), Math.round(ppu * 1.15)));
      /* and the whole drawing is centred in the stage. The axis used to be
         pinned 40 pixels off the bottom, so on a tall board the line hugged the
         floor with a band of nothing above it. */
      var contentH = HOPH + 22 + 26 + 6, top = Math.max(6, Math.round((H - contentH) / 2));
      AXIS = Math.round(Math.min(H - 40, top + HOPH + 22)); LABY = AXIS + 26;
    }
    function buildLine() {
      measure();
      while (elSvg.firstChild) elSvg.removeChild(elSvg.firstChild);
      elSvg.setAttribute('width', W); elSvg.setAttribute('height', H); elSvg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      elStage.style.width = W + 'px';
      elSvg.appendChild(mk('line', { x1: PADX - 10, y1: AXIS, x2: W - PADX + 10, y2: AXIS, 'class': 'nl-axis' }));
      var LSTEP = labStep(), sparse = LSTEP > tstep(), wk = walkOf(q); labs = {};
      function addLab(v, maj, zero) {
        if (labs[v]) return;
        var t = mk('text', { x: X(v), y: LABY, 'class': 'nl-lab' + (zero ? ' zero' : (maj ? ' maj' : '')) + ((sparse && !maj && !zero) ? ' dim' : '') });
        t.textContent = num(v); elSvg.appendChild(t); labs[v] = t;
      }
      for (var v = vLo; v <= vHi; v += tstep()) {
        var x = X(v), maj = (v % MSTEP === 0), zero = (v === 0), half = zero ? 14 : (maj ? 11 : 7);
        elSvg.appendChild(mk('line', { x1: x, y1: AXIS - half, x2: x, y2: AXIS + half, 'class': 'nl-tick' + (zero ? ' zero' : (maj ? ' maj' : '')) }));
        /* every whole number carries a label while it is being tapped: a pupil
           cannot aim at a number that is not written on the line */
        if (zero || v % LSTEP === 0) addLab(v, maj || (sparse && LSTEP > 1), zero);
      }
      /* the two numbers the sum actually names always carry a label */
      [wk.start, wk.end].forEach(function (v) { if (v >= vLo && v <= vHi) addLab(v, false, v === 0); });
      hopHost = mk('g', {}); elSvg.appendChild(hopHost);
      elGhost = mk('circle', { cx: 0, cy: AXIS, r: 11, 'class': 'nl-ghost' }); elSvg.appendChild(elGhost);
      elSpot = mk('circle', { cx: 0, cy: AXIS, r: 17, 'class': 'nl-spot' }); elSvg.appendChild(elSpot);
      elMarker = mk('g', { 'class': 'nl-marker' });
      elMarker.appendChild(mk('circle', { cx: 0, cy: AXIS, r: 9, 'class': 'nl-halo' }));
      elMarker.appendChild(mk('line', { x1: 0, y1: AXIS - 15, x2: 0, y2: AXIS + 15, 'class': 'nl-marker-stem' }));
      elMarker.appendChild(mk('circle', { cx: 0, cy: AXIS, r: 9, 'class': 'nl-marker-dot' }));
      elSvg.appendChild(elMarker);
      buildHits();
      showMarker(markerShown);
      placeMarker(curV, false);
      syncFades();
    }
    function buildHits() {
      elHits.innerHTML = ''; hits = {}; hitList = [];
      var TS = tstep();
      for (var v = vLo; v <= vHi; v += TS) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'nl-hit';
        b.style.left = (X(v) - ppu * TS / 2) + 'px'; b.style.width = (ppu * TS) + 'px';
        b.setAttribute('data-v', v); b.setAttribute('aria-label', say(v)); b.disabled = true;
        elHits.appendChild(b); hits[v] = b; hitList.push({ v: v, b: b });
      }
      armHits(hitsOn, hitsPred);
    }
    function armHits(on, pred) {
      hitsOn = !!on; hitsPred = pred || null;
      elHits.classList.toggle('is-live', hitsOn);
      for (var i = 0; i < hitList.length; i++) hitList[i].b.disabled = !hitsOn || (hitsPred ? !hitsPred(hitList[i].v) : false);
    }
    function labAt(v) { return labs[v] || null; }
    function clearLabelStates() { Object.keys(labs).forEach(function (k) { labs[k].classList.remove('is-live', 'is-from', 'is-land', 'is-yield'); }); }
    /* A lit label (where the marker is, where the walk started, where it
       landed) is drawn bigger, and on a phone's short line it landed on top of
       the nearest major: "-15" over "-13". While a label is lit, an unlit
       neighbour close enough to collide steps out of the way, and comes back
       when the states clear. Only while lit: the end of the walk is written
       on the line from the start (invisible until it is reached), and taking a
       major away for it left a gap in the scale. */
    function isLit(t) { return t.classList.contains('is-live') || t.classList.contains('is-from') || t.classList.contains('is-land'); }
    function labW(t) { try { return t.getBBox().width; } catch (e) { return String(t.textContent).length * 9; } }
    function yieldAround(t) {
      var x0 = +t.getAttribute('x'), w0 = labW(t);
      Object.keys(labs).forEach(function (k) {
        var o = labs[k]; if (o === t || isLit(o)) return;
        if (Math.abs(+o.getAttribute('x') - x0) < (w0 + labW(o)) / 2 + 6) o.classList.add('is-yield');
      });
    }
    function markLabel(v, cls) { var t = labAt(v); if (t) { t.classList.add(cls); t.classList.remove('is-yield'); yieldAround(t); } }
    function showMarker(on) { markerShown = !!on; if (elMarker) elMarker.style.opacity = on ? '1' : '0'; }
    function placeMarker(v, animate) {
      curV = v; if (!elMarker) return;
      if (!animate || fast) { elMarker.classList.add('no-anim'); elMarker.style.transform = 'translate(' + X(v) + 'px,0px)'; void elMarker.getBoundingClientRect(); elMarker.classList.remove('no-anim'); }
      else elMarker.style.transform = 'translate(' + X(v) + 'px,0px)';
      clearLabelStates(); markLabel(v, 'is-live'); panIfNeeded(v, animate);
    }
    function frameSum(smooth) {
      var w = elScroll.clientWidth, wk = walkOf(q), lo = Math.min(wk.start, wk.end), hi = Math.max(wk.start, wk.end);
      camLock = (hi - lo + 2) * ppu <= w;
      panTo(Math.round((lo + hi) / 2), smooth);
    }
    function panIfNeeded(v, smooth) {
      if (camLock) return;
      var w = elScroll.clientWidth; if (elScroll.scrollWidth <= w + 2) return;
      var x = X(v), left = elScroll.scrollLeft, pad = Math.max(46, w * 0.16);
      if (x > left + pad && x < left + w - pad) return;
      panTo(v, smooth);
    }
    var panTimer = null;
    function panTo(v, smooth) {
      var w = elScroll.clientWidth; if (elScroll.scrollWidth <= w + 2) return;
      var target = Math.max(0, Math.min(elScroll.scrollWidth - w, X(v) - w / 2));
      clearInterval(panTimer); panTimer = null;
      if (!smooth || fast) { elScroll.scrollLeft = target; return; }
      var from = elScroll.scrollLeft, steps = 12, i = 0;
      panTimer = setInterval(function () { i++; var t = i / steps, e = 1 - Math.pow(1 - t, 3); elScroll.scrollLeft = from + (target - from) * e; if (i >= steps) { clearInterval(panTimer); panTimer = null; elScroll.scrollLeft = target; } }, 20);
    }
    function syncFades() { var max = elScroll.scrollWidth - elScroll.clientWidth; elBox.classList.toggle('can-l', elScroll.scrollLeft > 4); elBox.classList.toggle('can-r', elScroll.scrollLeft < max - 4); }
    elScroll.addEventListener('scroll', syncFades);
    function popMarker() { if (!elMarker || fast) return; elMarker.classList.remove('is-pop'); void elMarker.getBoundingClientRect(); elMarker.classList.add('is-pop'); }
    function setGhost(v, on) { if (!elGhost) return; elGhost.setAttribute('cx', X(v)); elGhost.classList.toggle('is-on', !!on); }
    function setSpot(v, on) { if (!elSpot) return; elSpot.setAttribute('cx', X(v)); elSpot.classList.toggle('is-on', !!on); }
    function clearHops() { if (!hopHost) return; while (hopHost.firstChild) hopHost.removeChild(hopHost.firstChild); root.classList.remove('dir-l', 'dir-r', 'walk-neutral'); if (elMarker) elMarker.classList.remove('is-landed'); }
    /* Every jump taken so far stays on the line, but a wall of fifteen equally
       bright arcs is a wall to read. Each jump goes in its own group and the
       older groups are dimmed, so the eye lands on the jump just taken and the
       ones behind it read as a trail. */
    function fadeHops() {
      if (!hopHost) return;
      var g = hopHost.querySelectorAll('.nl-hopg'), n = g.length, i, age;
      for (i = 0; i < n; i++) {
        age = n - 1 - i;
        g[i].style.opacity = age === 0 ? '1' : String(Math.max(0.34, 0.78 - (age - 1) * 0.08));
      }
    }
    /* a solid head with its tip at (ex, ey), pointing along the unit vector (ux, uy):
       the same head the sequences kit draws (Aadam 2026-09-16, "improve the look of the arrows") */
    function headD(ex, ey, ux, uy, len, half) {
      var bx = ex - ux * len, by = ey - uy * len, px = -uy * half, py = ux * half, r1 = function (v) { return Math.round(v * 10) / 10; };
      return 'M ' + r1(ex) + ' ' + r1(ey) + ' L ' + r1(bx + px) + ' ' + r1(by + py) + ' Q ' + r1(bx + ux * len * 0.28) + ' ' + r1(by + uy * len * 0.28) + ' ' + r1(bx - px) + ' ' + r1(by - py) + ' Z';
    }
    function addHop(from, to, label) {
      var x1 = X(from), x2 = X(to), midX = (x1 + x2) / 2, apex = AXIS - HOPH;
      var g = mk('g', { 'class': 'nl-hopg' });
      var p = mk('path', { d: 'M' + x1 + ' ' + AXIS + ' Q' + midX + ' ' + (AXIS - HOPH * 2) + ' ' + x2 + ' ' + AXIS, 'class': 'nl-hop' });
      g.appendChild(p);
      /* a jump says which way it went: a head where it lands, lying along the arc */
      var hux = x2 - midX, huy = HOPH * 2, hul = Math.sqrt(hux * hux + huy * huy) || 1;
      var hd = mk('path', { d: headD(x2, AXIS, hux / hul, huy / hul, 10, 4.6), 'class': 'nl-hophead' });
      g.appendChild(hd); setTimeout(function () { hd.classList.add('is-on'); }, 10);
      if (ppu >= 20) { var t = mk('text', { x: midX, y: apex - 3, 'class': 'nl-hopn' }); t.textContent = String(label); g.appendChild(t); setTimeout(function () { t.classList.add('is-on'); }, 10); }
      hopHost.appendChild(g); fadeHops();
      setTimeout(function () { p.classList.add('is-on'); }, 10);
    }
    function flashDirection(from, dir) {
      /* just above the top of an arc, not two arcs up: the arcs grow with the
         line now, and the old spacing pinned this to the ceiling */
      var y = Math.max(12, AXIS - HOPH - 22);
      var span = Math.max(60, Math.min(3.4 * ppu, 150)), x1 = X(from), x2 = x1 + dir * span;
      var head = headD(x2, y, dir > 0 ? 1 : -1, 0, 11, 5.5);
      var col = dir > 0 ? 'var(--right)' : 'var(--left)';
      var p = mk('path', { d: 'M' + x1 + ' ' + y + 'L' + x2 + ' ' + y, 'class': 'nl-hop', style: 'stroke:' + col });
      var h = mk('path', { d: head, 'class': 'nl-hophead', style: 'fill:' + col });
      var g = mk('g', { 'class': 'nl-flashg' });
      g.appendChild(p); g.appendChild(h); hopHost.appendChild(g);
      setTimeout(function () { p.classList.add('is-on'); h.classList.add('is-on'); }, 10);
    }
    function runWalk(list, speed, done) {
      var i = -1;
      if (!list.length) { if (done) later(done, 10); return; }
      function stepOne() {
        i++; var h = list[i];
        addHop(h[0], h[1], h[2]); placeMarker(h[1], true);
        if (i < list.length - 1) later(stepOne, speed); else if (done) later(done, speed);
      }
      later(stepOne, 10);
    }

    /* ---------- expression ---------- */
    var EX = {};
    function renderExpr() {
      elExpr.innerHTML = '';
      EX = { a: null, asign: null, anum: null, op: null, b: null, bsign: null, bnum: null, eq: null, res: null };
      function span(cls, txt) { var e = document.createElement('span'); e.className = cls; e.textContent = txt; elExpr.appendChild(e); return e; }
      EX.a = span('nl-tok nl-tok--a', '');
      if (q.a < 0) { EX.asign = document.createElement('span'); EX.asign.className = 'nl-asign'; EX.asign.textContent = MINUS; EX.a.appendChild(EX.asign); }
      EX.anum = document.createElement('span'); EX.anum.className = 'nl-anum'; EX.anum.textContent = String(Math.abs(q.a)); EX.a.appendChild(EX.anum);
      EX.op = span('nl-tok nl-tok--op', opGlyph(q));
      EX.b = span('nl-tok nl-tok--b', '');
      if (q.b < 0) { EX.bsign = document.createElement('span'); EX.bsign.className = 'nl-bsign'; EX.bsign.textContent = MINUS; EX.b.appendChild(EX.bsign); }
      EX.bnum = document.createElement('span'); EX.bnum.className = 'nl-bnum'; EX.bnum.textContent = String(Math.abs(q.b)); EX.b.appendChild(EX.bnum);
      EX.eq = span('nl-tok nl-eq', '=');
      EX.res = span('nl-tok nl-res', '?');
    }
    function exAll() { return [EX.a, EX.op, EX.b, EX.eq, EX.res]; }
    function focusTokens(which) { elExpr.classList.add('is-guided'); exAll().forEach(function (t) { if (t) t.classList.remove('is-focus'); }); which.forEach(function (t) { if (t) t.classList.add('is-focus'); }); }
    function dimPart(e, on) { if (e) e.classList.toggle('is-dimpart', !!on); }
    function clearFocus() { elExpr.classList.remove('is-guided'); exAll().forEach(function (t) { if (t) t.classList.remove('is-focus'); }); dimPart(EX.bnum, false); dimPart(EX.bsign, false); clearSignFocus(); }
    function focusSigns() { focusTokens([EX.a, EX.b]); if (EX.asign) { EX.asign.classList.add('is-lit'); dimPart(EX.anum, true); } if (EX.bsign) { EX.bsign.classList.add('is-lit'); dimPart(EX.bnum, true); } }
    function clearSignFocus() { if (EX.asign) EX.asign.classList.remove('is-lit'); if (EX.bsign) EX.bsign.classList.remove('is-lit'); dimPart(EX.anum, false); dimPart(EX.bnum, false); }
    function setRes(txt, on) { if (!EX.res) return; EX.res.textContent = txt; EX.res.classList.toggle('is-on', !!on); if (on) { EX.res.classList.remove('is-new'); void EX.res.getBoundingClientRect(); EX.res.classList.add('is-new'); } }
    function litSigns(on) { if (EX.op) EX.op.classList.toggle('is-lit', !!on); if (EX.bsign) EX.bsign.classList.toggle('is-lit', !!on); }
    function combineSigns(done) {
      var eff = effOf(q), dir = eff > 0 ? 'r' : 'l';
      function finish() {
        if (EX.op) { EX.op.textContent = eff > 0 ? '+' : MINUS; EX.op.className = 'nl-tok nl-tok--op dir-' + dir + ' is-new'; }
        if (EX.bsign && EX.bsign.parentNode) { EX.bsign.parentNode.removeChild(EX.bsign); EX.bsign = null; }
        if (EX.b) EX.b.className = 'nl-tok nl-tok--b dir-' + dir;
        root.classList.remove('dir-l', 'dir-r'); root.classList.add('dir-' + dir);
        if (done) done();
      }
      if (!EX.bsign || fast) { litSigns(false); finish(); return; }
      litSigns(false); EX.op.classList.add('is-slide-r'); EX.bsign.classList.add('is-slide-l');
      later(function () { EX.op.classList.remove('is-slide-r'); finish(); }, 260);
    }

    /* ---------- captions ---------- */
    function sg(neg, cls) { return '<span class="sg' + (cls ? ' ' + cls : '') + '">' + (neg ? MINUS : '+') + '</span>'; }
    function opChip() { return sg(q.op !== '+'); }
    function dirWord(eff) { return '<b class="big ' + (eff > 0 ? 'r' : 'l') + '">' + (eff > 0 ? '&#8594; right' : '&#8592; left') + '</b>'; }
    function wayCaption(merged) {
      var eff = effOf(q);
      if (q.b >= 0) return merged ? opChip() + '<span class="word">means ' + (q.op === '+' ? 'add' : 'subtract') + ': go</span> ' + dirWord(eff) : opChip();
      var pair = opChip() + '<span class="word">and</span>' + sg(true);
      if (!merged) return pair;
      return pair + '<span class="word">make</span>' + sg(eff < 0, 'out ' + (eff > 0 ? 'r' : 'l')) + '<span class="word" style="margin-left:0">,</span><br><span class="word">so ' + (eff > 0 ? 'add' : 'subtract') + ': go</span> ' + dirWord(eff);
    }
    function moveCaption(lead) {
      var d = distOf(q), h = hops();
      if (TWO && h.length === 2) {
        return '<span class="word">' + lead + '</span> ' + dirWord(effOf(q)) + ' <b class="big">' + h[0][2] + '</b> <span class="word">to zero, then</span> <b class="big">' + h[1][2] + '</b> <span class="word">more</span>';
      }
      if (TWO) return '<span class="word">' + lead + '</span> ' + dirWord(effOf(q)) + ' <b class="big">' + d + '</b> <span class="word">in one jump</span>';
      return '<span class="word">' + lead + '</span> ' + dirWord(effOf(q)) + ' <b class="big">' + d + '</b> <span class="word">place' + (d === 1 ? '' : 's') + '</span>';
    }
    function signCaption(merged) {
      var eff = effOf(q), same = (q.a < 0) === (q.b < 0);
      var pair = sg(q.a < 0) + '<span class="word">and</span>' + sg(q.b < 0);
      if (!merged) return pair;
      var out = sg(eff < 0, 'out ' + (eff > 0 ? 'r' : 'l'));
      var line2 = (q.op === 'x') ? '<span class="word">so go</span> ' + dirWord(eff) + ' <span class="word">from 0</span>'
        : '<span class="word">so the quotient is</span> <b class="big ' + (eff > 0 ? 'r' : 'l') + '">' + (eff > 0 ? 'positive' : 'negative') + '</b>';
      return pair + '<span class="word">' + (same ? 'same, so' : 'different, so') + '</span>' + out + '<br>' + line2;
    }
    function jumpsCaption() {
      var w = walkOf(q), c = (effOf(q) > 0 ? 'r' : 'l');
      if (q.op === 'x') return '<b class="sg ' + c + '">' + w.n + '</b><span class="word">jumps of</span><b class="sg ' + c + '">' + w.size + '</b><br><span class="word">going</span> ' + dirWord(w.dir) + ' <span class="word">from 0</span>';
      return '<span class="word">Jump</span><b class="sg">' + w.size + '</b><span class="word">at a time, back to 0</span><br><span class="word">and count the jumps</span>';
    }
    function countCaption(n) { return '<b class="big">' + n + '</b> <span class="word">jump' + (n === 1 ? '' : 's') + '</span>'; }
    function setCap(html, kind) { elCap.className = 'nl-cap' + (kind ? ' is-' + kind : ''); elCap.innerHTML = '<span>' + html + '</span>'; }

    /* ---------- the three presses ---------- */
    var LABELS = isMD(q) ? ['Sign', 'Jumps', 'Land'] : ['Start', 'Which way', 'Move'];
    var CTAS = isMD(q) ? ['Look at the signs', 'Do the jumps', 'Land'] : ['Find the start', 'Which way?', 'Move'];
    function reset() {
      clearTimers(); lStep = 0; setBusy(false);
      clearHops(); clearLabelStates();
      renderExpr(); clearFocus();
      showMarker(false); setGhost(walkOf(q).start, false); setSpot(0, false);
      frameSum(true);
      /* in Your turn the line answers the question, so the start-tap is off and
         the checkpoint owns the hits. reset() runs again on every relayout, so
         it must not disarm what the checkpoint armed. */
      if (quiz) { /* Your turn owns the taps */ }
      else if (isMD(q)) armHits(false);
      else armHits(true, function (v) { return SHAPES_AS[q.s].aNeg ? v < 0 : v > 0; });
      api.steps(LABELS); api.step(0);
      setCap(quiz ? '' : 'Press <b>' + CTAS[0] + '</b>');
      api.cta(CTAS[0]);
      api.hint(isMD(q) ? 'Two signs decide the sign of the answer. Then jump along the line.' : 'Three moves: where you start, which way, how far.');
    }
    function lsStart() {
      focusTokens([EX.a]); showMarker(true); placeMarker(q.a, true); setGhost(q.a, true); setSpot(q.a, true); markLabel(q.a, 'is-from');
      setCap('<span class="word">Start at</span> <b class="big">' + num(q.a) + '</b>');
      api.cta(CTAS[1]); api.hint('Now look at the operation and the sign of the second number.');
    }
    function lsWay() {
      setBusy(true); setSpot(0, false);
      if (q.b < 0) { focusTokens([EX.op, EX.b]); dimPart(EX.bnum, true); } else focusTokens([EX.op]);
      setCap(wayCaption(false));
      later(function () {
        combineSigns(function () {
          var eff = effOf(q); focusTokens([EX.op]); flashDirection(q.a, eff); setCap(wayCaption(true)); setBusy(false);
          api.cta(CTAS[2]); api.hint('How many places? The size of the second number, ignoring its sign.');
        });
      }, 750);
    }
    function lsMove() {
      setBusy(true);
      /* sign first (Aadam 2026-09-16): the number never lights without its sign.
         combineSigns has already folded b's sign into the op token by this press,
         so that token IS the sign printed with b and lights with it */
      focusTokens([EX.op, EX.b]); dimPart(EX.bnum, false); dimPart(EX.bsign, false);
      setCap(moveCaption('Move'));
      later(function () { runWalk(hops(), TWO ? 620 : 400, function () { revealAnswer(); }); }, 550);
    }
    function lsSign() {
      setBusy(true);
      var w = walkOf(q), eff = effOf(q);
      focusSigns(); setCap(signCaption(false));
      later(function () {
        root.classList.remove('dir-l', 'dir-r'); root.classList.add('dir-' + (eff > 0 ? 'r' : 'l'));
        if (q.op === '/') root.classList.add('walk-neutral');
        showMarker(true); placeMarker(w.start, true); setGhost(w.start, true); markLabel(w.start, 'is-from'); flashDirection(w.start, w.dir);
        setCap(signCaption(true)); setBusy(false);
        api.cta(CTAS[1]); api.hint(q.op === 'x' ? 'A product is jumps of the first number from 0.' : 'A quotient jumps back to 0. Count the jumps.');
      }, 750);
    }
    function lsJumps() {
      setBusy(true);
      var w = walkOf(q);
      clearSignFocus(); focusTokens([EX.a, EX.b]); setCap(jumpsCaption());
      later(function () {
        runWalk(hops(), 400, function () {
          if (q.op === '/') setCap(countCaption(w.n));
          setBusy(false); api.cta(CTAS[2]); api.hint(q.op === '/' ? 'The count is the size of the answer. The sign puts it on the line.' : 'Where did the last jump land?');
        });
      }, 550);
    }
    function lsLand() {
      setBusy(true); clearFocus();
      if (q.op === '/') { placeMarker(q.ans, true); later(function () { revealAnswer(); }, 380); }
      else revealAnswer();
    }
    function revealAnswer() {
      setRes(num(q.ans), true); markLabel(q.ans, 'is-land'); setSpot(q.ans, true);
      if (elMarker) elMarker.classList.add('is-landed');
      popMarker(); clearFocus();
      setCap('<span class="big"><b>' + qText(q) + ' = ' + num(q.ans) + '</b></span>', 'ok');
      setBusy(false); api.step(3); api.hint(''); api.done();
    }
    function learnNext() {
      if (busy || dead) return;
      if (lStep >= 3) return;
      lStep++;
      api.step(lStep);
      if (isMD(q)) { if (lStep === 1) lsSign(); else if (lStep === 2) lsJumps(); else lsLand(); }
      else { if (lStep === 1) lsStart(); else if (lStep === 2) lsWay(); else lsMove(); }
    }
    /* Answer only, and Show it all: the finished picture in one paint. No steps
       replayed at speed, nothing moves. The rule for every skill. */
    function all() {
      if (dead) return;
      clearTimers(); setBusy(false);
      var w = walkOf(q), eff = effOf(q), from = w.start, i;
      clearHops(); clearLabelStates();
      renderExpr(); clearFocus();
      armHits(false);
      root.classList.add('dir-' + (eff > 0 ? 'r' : 'l'));
      if (q.op === '/') root.classList.add('walk-neutral');
      if (!isMD(q)) { if (EX.op) { EX.op.textContent = eff > 0 ? '+' : MINUS; EX.op.className = 'nl-tok nl-tok--op dir-' + (eff > 0 ? 'r' : 'l'); } if (EX.bsign && EX.bsign.parentNode) { EX.bsign.parentNode.removeChild(EX.bsign); EX.bsign = null; } if (EX.b) EX.b.className = 'nl-tok nl-tok--b dir-' + (eff > 0 ? 'r' : 'l'); }
      setGhost(w.start, true); markLabel(w.start, 'is-from');
      hops().forEach(function (h) { addHop(h[0], h[1], h[2]); });
      /* the whole walk arrives in one paint here, so no jump is older than any
         other: the trail fade belongs to the stepped version only */
      Array.prototype.forEach.call(hopHost.querySelectorAll('.nl-hopg'), function (g) { g.style.opacity = '1'; });
      showMarker(true); placeMarker(q.ans, false);
      setRes(num(q.ans), true); markLabel(q.ans, 'is-land'); setSpot(q.ans, true);
      if (elMarker) elMarker.classList.add('is-landed');
      frameSum(false);
      setCap('<span class="big"><b>' + qText(q) + ' = ' + num(q.ans) + '</b></span>', 'ok');
      lStep = 3; api.step(3); api.hint(''); api.done();
    }

    /* tapping the line moves the start of a sum: a fresh question with that a */
    elHits.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.getAttribute || t.getAttribute('data-v') === null) return;
      var v = Number(t.getAttribute('data-v'));
      if (quiz) { quiz.onTap(v); return; }
      if (isMD(q)) return;
      if (SHAPES_AS[q.s].aNeg ? v >= 0 : v <= 0) return;
      var L = LEVELS[LVL - 1];
      var nq = makeAS(q.s, {}, v, rangeOf(L && L.rg));
      q = nq;
      api.replace(pack(q, LVL));
      reset();
    });

    /* A step cannot be un-drawn - the walk is a picture that got built - so
       going back means building it again and driving it forward to the step
       before, with the animation off. The resize handler wants exactly the
       same thing, so both go through here. */
    function driveTo(target) {
      if (dead) return;
      clearTimers(); setBusy(false);
      if (target >= 3) { all(); return; }
      if (target <= 0) { reset(); return; }
      fast = true; reset();
      (function drive() {
        if (dead) return;
        if (lStep >= target && !busy) { fast = baseFast; return; }
        if (!busy) learnNext();
        setTimeout(drive, 25);
      })();
    }
    function learnBack() { if (dead || lStep <= 0) return; driveTo(lStep - 1); }
    var rzTimer = null;
    function relayout() {
      if (dead) return;
      /* never rebuild mid-walk: the rebuild clears the timers the walk is
         riding on, and the step would never finish */
      if (busy) { clearTimeout(rzTimer); rzTimer = setTimeout(relayout, 200); return; }
      var target = lStep; buildLine(); driveTo(target);
    }
    function onResize() {
      if (dead) return;
      clearTimeout(rzTimer);
      rzTimer = setTimeout(relayout, 160);
    }
    window.addEventListener('resize', onResize);

    /* ---------- Your turn ----------
       The three decisions the sum asks for, in order, each with the name that
       goes on the step bar and the sentence the results screen reports it under.
       These ARE the diagnostic: a child who lands every start and every jump but
       misses the direction has one thing wrong, and it says so. */
    function askAt(i) {
      var w = walkOf(q), eff = effOf(q);
      if (isMD(q)) {
        if (i === 0) return { kind: 'sign', sign: eff, name: 'Sign', diag: 'Choosing the sign',
          prompt: 'Same signs or different? Pick the sign of the answer.' };
        if (i === 1) {
          /* one jump lands on the answer itself in the smallest divide there is
             (−4 ÷ 2 lands on −2, which IS the answer), and then the last
             checkpoint would be a free tap. Ask for two jumps instead. */
          var k = ((w.start + w.dir * w.size) === q.ans && w.n >= 2) ? 2 : 1;
          return { kind: 'value', v: w.start + k * w.dir * w.size, jumps: k, name: 'Jumps', diag: 'Counting the jumps',
            prompt: k === 1 ? 'Tap where ONE jump of ' + w.size + ' lands.' : 'Tap where TWO jumps of ' + w.size + ' land.' };
        }
        return { kind: 'value', v: q.ans, name: 'Land', diag: 'Landing on the answer', prompt: 'Tap the answer.' };
      }
      if (i === 0) return { kind: 'value', v: q.a, name: 'Start', diag: 'Finding the start',
        prompt: 'Tap the number the calculation starts on.' };
      if (i === 1) return { kind: 'dir', dir: eff, name: 'Which way', diag: 'Choosing the direction',
        prompt: 'Which way does it go from there?' };
      return { kind: 'value', v: q.ans, name: 'Move', diag: 'Counting to the answer',
        prompt: 'Tap the number you land on.' };
    }
    /* the first jump or two, drawn on their own: the multiply and divide walk is
       confirmed a jump at a time before the whole run goes down */
    function hopOnce(k) {
      var w = walkOf(q), from = w.start, i;
      k = Math.max(1, k || 1);
      showMarker(true); placeMarker(w.start, false); setGhost(w.start, true); markLabel(w.start, 'is-from');
      root.classList.remove('dir-l', 'dir-r'); root.classList.add('dir-' + (w.dir > 0 ? 'r' : 'l'));
      for (i = 1; i <= k; i++) { var to = from + w.dir * w.size; addHop(from, to, String(i)); placeMarker(to, i === k); from = to; }
    }
    function flashWrong(v) {
      var t = labAt(v);
      if (t) { t.classList.add('is-wrong'); setTimeout(function () { if (t) t.classList.remove('is-wrong'); }, 900); }
      root.classList.remove('is-shake'); void root.getBoundingClientRect(); root.classList.add('is-shake');
      setTimeout(function () { root.classList.remove('is-shake'); }, 380);
    }

    buildLine();
    reset();
    /* the box is not at its final width the moment the board is mounted, so lay
       the line out again whenever that width really moves (see SL.watchWidth) */
    var stopW = SL.watchWidth(elScroll, function () { onResize(); });
    return {
      next: learnNext,
      back: learnBack,
      all: all,
      /* Your turn: the same model, gated on the pupil answering first */
      ask: askAt,
      busy: function () { return busy; },
      hopOnce: hopOnce,
      wrong: flashWrong,
      arm: function (on) { armHits(!!on, null); },
      quizOn: function (o) {
        quiz = o; quizMode = !!o; computeScale(); buildLine();
        if (o) { armHits(false); setCap(''); frameSum(false); }
      },
      destroy: function () { dead = true; clearTimers(); clearTimeout(rzTimer); clearInterval(panTimer); stopW(); window.removeEventListener('resize', onResize); }
    };
  }


  /* ============================================================
     YOUR TURN
     The same model, but the pupil answers each decision before it is
     drawn: tap the start, choose the way, tap where you land (and for
     multiply and divide: the sign, one jump, the answer). Core keeps
     the score; every checkpoint is reported on its FIRST try, because
     a child who gets there on the third go has not got there.
     ============================================================ */
  function turn(host, item, api) {
    var q = item.data, dead = false, timers = [];
    var CP = [], i = 0, firstTry = true, allOK = true, slot = null, waiting = false;
    /* one mark per checkpoint, ever: Show me records the ones never attempted */
    var did = [false, false, false];
    /* the pause between a right answer and the model moving is a beat to look at
       what just happened; under reduced motion there is nothing to look at */
    function later(fn, ms) { var t = setTimeout(function () { if (!dead) fn(); }, api.reduceMotion ? Math.min(ms, 12) : ms); timers.push(t); return t; }

    /* teach writes to its own chrome; here that chrome is Your turn's, so every
       call is swallowed except the one that says the model has finished */
    var r = teach(host, item, {
      hint: function () {}, cta: function () {}, steps: function () {}, step: function () {},
      done: function () { finish(); }, replace: function () {}, reduceMotion: api.reduceMotion
    });
    r.quizOn({ onTap: onTap });
    CP = [r.ask(0), r.ask(1), r.ask(2)];
    var nl = host.querySelector('.sl-nl');
    if (nl) {
      var note = nl.querySelector('.nl-tapnote');
      if (note && note.parentNode) note.parentNode.removeChild(note);
      slot = document.createElement('div'); slot.className = 'nl-choose'; nl.appendChild(slot);
    }

    api.steps(CP.map(function (c) { return { name: c.name, diag: c.diag }; }));

    function clearSlot() { if (slot) { slot.innerHTML = ''; slot.classList.remove('is-on'); } }
    function choiceHTML(label, val, cls) {
      return '<button type="button" class="nl-cbtn' + (cls ? ' ' + cls : '') + '" data-c="' + val + '">' + label + '</button>';
    }
    function drawChoices(c) {
      if (!slot) return;
      slot.classList.add('is-on');
      if (c.kind === 'dir') {
        slot.innerHTML = choiceHTML('&#8592; Left', '-1', 'l') + choiceHTML('Right &#8594;', '1', 'r');
      } else {
        slot.innerHTML = choiceHTML('<b>Same signs</b><span>the answer is +</span>', '1', 'r') +
          choiceHTML('<b>Different signs</b><span>the answer is ' + MINUS + '</span>', '-1', 'l');
      }
    }
    if (slot) slot.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.nl-cbtn') : null;
      if (!t || waiting || dead) return;
      var c = CP[i], given = Number(t.getAttribute('data-c'));
      var want = (c.kind === 'dir') ? c.dir : c.sign;
      if (given === want) { t.classList.add('is-right'); answered(true); }
      else {
        t.classList.add('is-wrong');
        (function (b) { later(function () { b.classList.remove('is-wrong'); }, 800); })(t);
        answered(false);
      }
    });

    function onTap(v) {
      if (waiting || dead) return;
      var c = CP[i]; if (c.kind !== 'value') return;
      if (v === c.v) answered(true, v); else { r.wrong(v); answered(false, v); }
    }

    /* one mark per checkpoint, taken on the first answer given to it */
    function answered(ok, v) {
      var c = CP[i];
      if (firstTry) { api.mark(i, ok, c); did[i] = true; firstTry = false; if (!ok) allOK = false; }
      if (!ok) { api.hint(missHint(c)); return; }
      waiting = true; r.arm(false); clearSlot();
      api.hint('');
      advance();
    }
    function missHint(c) {
      if (c.kind === 'dir') return 'Not that way. Look at the operation and the sign of the second number again.';
      if (c.kind === 'sign') return 'Not that one. Two signs the same give a positive; different signs give a negative.';
      if (i === 0) return 'That is not where it starts. The first number in the calculation is the starting place.';
      if (isMD(q) && i === 1) return (CP[1] && CP[1].jumps > 1)
        ? 'Not there. Two jumps, each the size of the number you are counting in.'
        : 'Not there. One jump only, and it is the size of the number you are counting in.';
      return 'Not there. Count along the line and try again.';
    }
    /* what the model does once a checkpoint is right. Multiply and divide keep
       the whole run back until the answer has been named, or the line would
       hand it over before the question was asked. */
    function advance() {
      if (isMD(q) && i === 1) { r.hopOnce(CP[1].jumps || 1); later(function () { step(); }, 520); return; }
      if (isMD(q) && i === 2) { r.next(); whenFree(function () { r.next(); }); return; }
      r.next();
      whenFree(function () { step(); });
    }
    function whenFree(fn) {
      (function poll() { if (dead) return; if (r.busy()) { later(poll, 60); return; } fn(); })();
    }
    function step() {
      if (dead) return;
      if (i >= CP.length - 1) return;   /* the last one finishes through teach's done */
      i++; firstTry = true; waiting = false;
      ask();
    }
    function ask() {
      var c = CP[i];
      api.step(i); api.prompt(c.prompt); api.hint(openHint(c));
      if (c.kind === 'value') { r.arm(true); clearSlot(); }
      else { r.arm(false); drawChoices(c); }
    }
    function openHint(c) {
      if (c.kind === 'value' && i === 0) return 'Every calculation starts somewhere. Find that number on the line.';
      if (c.kind === 'dir') return 'The two signs together decide the direction. Different signs go left.';
      if (c.kind === 'sign') return 'Same signs give a positive, different signs give a negative.';
      if (isMD(q) && i === 1) return (CP[1] && CP[1].jumps > 1)
        ? 'Two jumps of the same size, from where the walk starts.'
        : 'A product is jumps of the same size. Where does the first one land?';
      return '';
    }
    var ended = false;
    function finish() {
      if (ended || dead) return;
      ended = true; waiting = true;
      r.arm(false); clearSlot();
      api.step(CP.length);
      api.prompt('<b>' + qText(q) + ' = ' + num(q.ans) + '</b>');
      api.hint('');
      api.done(allOK);
    }

    ask();
    return {
      /* Show me: the rest of the question counts as missed, then the finished
         picture goes down in one paint, the same as Answer only */
      reveal: function () {
        if (ended || dead) return;
        for (var k = i; k < CP.length; k++) if (!did[k]) { api.mark(k, false, CP[k]); did[k] = true; allOK = false; }
        waiting = true; r.arm(false); clearSlot();
        r.all();
      },
      destroy: function () { dead = true; timers.forEach(clearTimeout); timers = []; try { r.destroy(); } catch (e) {} }
    };
  }

  SL.register({
    id: 'negative-numbers', name: 'Negative numbers', short: 'Negatives', strand: 'number', stage: 'secondary',
    colour: 'blue', icon: 'numberline', eg: MINUS + '4 ' + MINUS + ' 3,  7 × ' + MINUS + '2',
    blurb: 'Where you start, which way you go and how far. Then the sign rule for multiplying and dividing.',
    aliases: ['directed numbers', 'negatives', 'minus numbers', 'adding and subtracting negatives', 'multiplying negatives'],
    levels: LEVELS, make: make, teach: teach,
    turn: turn, turnName: 'Your turn',
    turnBlurb: 'Answer on the line in three taps. It says which decision you miss.'
  });
})();
